export default {
    updateRecurringBookingInfo: 'Please note that the changes will apply to any future bookings that have not yet been created, except for the reservation type, which will apply to all related bookings, both past and future.',
    updateReservationTypeTooltip: 'The selected reservation type will apply to all related bookings, both past and future.'
}